import { get, post } from './req'

// 获取导航栏 
export const GetNavColumnsByDid = p => get('api/WebAPI/GetNavColumnsByDid', p);

//轮播图
export const GetFilesInfoByCid = p => get('api/WebAPI/GetFilesInfoByCid', p);

//首页新闻资讯 列表 /api/WebAPI/GetNewsInfoByCid
export const GetNewsInfoByCid = p => get('api/WebAPI/GetNewsInfoByCid', p);

//查看列表数据详情 api/WebAPI/GetNewsInfoByNid?Nid=5
export const GetNewsInfoByNid = p => get('api/WebAPI/GetNewsInfoByNid', p);

//获取导航菜单下 子级导航 /api/WebAPI/GetFNavColumnsByCid
export const GetFNavColumnsByCid = p => get('api/WebAPI/GetFNavColumnsByCid', p);

// /api/WebAPI/GetCNavColumnsByCid
export const GetCNavColumnsByCid = p => get('api/WebAPI/GetCNavColumnsByCid', p);

//  /api/WebAPI/GetSinglePageInfoByCid
export const GetSinglePageInfoByCid = p => get('api/WebAPI/GetSinglePageInfoByCid', p);

//  /api/WebAPI/addMsg
export const addMsg = p => post('api/WebAPI/addMsg', p);

//获取招聘  /News/GetNews
export const GetNews = p => get('api/News/GetNews', p);


// /api/WebAPI/GetInfoBySearch
export const GetInfoBySearch = p => get('api/WebAPI/GetInfoBySearch', p);